import { getPalette } from '../ComplianceHub.helpers';
import type { BulkChoice } from './bulkChoiceFill';

export interface BulkChoiceFillButtonsProps {
  onFill: (choice: BulkChoice) => void;
  disabled?: boolean;
}

export function BulkChoiceFillButtons({
  onFill,
  disabled = false,
}: BulkChoiceFillButtonsProps) {
  const palette = getPalette();
  const buttons: ReadonlyArray<{
    choice: BulkChoice;
    label: string;
    background: string;
    textClass: string;
  }> = [
    { choice: '1', label: 'ใส่ 1 ทุกข้อ', background: palette.green, textClass: 'text-white' },
    { choice: '0', label: 'ใส่ 0 ทุกข้อ', background: palette.red, textClass: 'text-white' },
    { choice: 'NA', label: 'ใส่ NA ทุกข้อ', background: '#94A3B8', textClass: 'text-slate-800' },
  ];

  const handleFill = (choice: BulkChoice) => {
    if (disabled) {
      return;
    }
    onFill(choice);
  };

  return (
    <div
      className="flex flex-wrap justify-end gap-2"
      role="group"
      aria-label="ใส่คำตอบทุกข้อ 1/0/NA"
    >
      {buttons.map((button) => (
        <button
          key={button.choice}
          type="button"
          disabled={disabled}
          onClick={() => handleFill(button.choice)}
          className={`min-h-[44px] cursor-pointer rounded-full px-4 text-sm font-medium ${button.textClass} disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-900 focus-visible:ring-offset-2`}
          style={{ background: button.background }}
        >
          {button.label}
        </button>
      ))}
    </div>
  );
}
